import React from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import { Navigation } from "../../components/navigation";
import { Footer } from "../../components/footer";
import { featureFlags } from "../../content_option";
import "./style.css";

const JoinTabs = () => {
  const { pathname } = useLocation();
  const isCoffee = pathname.startsWith("/join/coffee");
  const isContact = pathname === "/join" || pathname.startsWith("/join/contact");

  // With Newsletter gone and Coffee Chat hidden, Contact is the only tab —
  // a single-tab bar reads as broken, so drop the bar entirely.
  if (!featureFlags.coffeeChat) return null;

  return (
    <div className="join-tabs">
      <Link to="/join/coffee" className={`join-tab ${isCoffee ? "active" : ""}`}>Coffee Chat</Link>
      <Link to="/join/contact" className={`join-tab ${isContact ? "active" : ""}`}>Contact</Link>
    </div>
  );
};

export const Join = () => {
  return (
    <>
      <Navigation />
      <div className="join-shell">
        <JoinTabs />
        <Outlet />
      </div>
      <Footer />
    </>
  );
};
